import React from "react";
import { Link } from "react-router-dom";

function BlogContent() {
    return (
        <>
            <br />
            <br />
            <br />
            <br />
            {/* <!-- blog-grid-main --> */}
            <div class="blog-grid-main">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-4 col-md-6 col-12">
                            <div class="blog-article-item">
                                <div class="article-thumb">
                                    <Link to="/blogdetails" className="item-link">
                                        <img class="lazyload" data-src="/assets/images/blog/blog-2.jpg" src="/assets/images/blog/blog-2.jpg" alt="img-blog" />
                                    </Link>
                                    <div class="article-label">
                                        <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Accessories</a>
                                    </div>
                                </div>
                                <div class="article-content">
                                    <div class="article-title">
                                        <Link to="/blogdetails" className="item-link">
                                            <a class="">The next generation of leather alternatives</a>
                                        </Link>
                                    </div>
                                    <div class="article-btn">
                                        <Link to="/blogdetails" className="item-link">
                                            <a class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">
                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-3.jpg" src="/assets/images/blog/blog-3.jpg" alt="img-blog" />
                                        </a>
                                        <div class="article-label">
                                            <a class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Accessories</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a class="">An Exclusive Clothing Collaboration</a>
                                        </div>
                                        <div class="article-btn">
                                            <a class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">

                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a  >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-4.jpg" src="/assets/images/blog/blog-4.jpg" alt="img-blog" />
                                        </a>
                                        <div class="article-label">
                                            <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Accessories</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a   class="">Hello Fashion by Colombian-American</a>
                                        </div>
                                        <div class="article-btn">
                                            <a   class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">

                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a  >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-5.jpg" src="/assets/images/blog/blog-5.jpg" alt="img-blog" />
                                        </a>
                                        <div class="article-label">
                                            <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Accessories</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a   class="">Christine Is A True Style Icon</a>
                                        </div>
                                        <div class="article-btn">
                                            <a   class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">

                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a  >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-6.jpg" src="/assets/images/blog/blog-6.jpg" alt="img-blog" />
                                        </a>
                                        <div class="article-label">
                                            <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Design</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a   class="">Effortlessly Blends The Carefree Style</a>
                                        </div>
                                        <div class="article-btn">
                                            <a   class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">

                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a  >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-7.jpg" src="/assets/images/blog/blog-7.jpg" alt="" />
                                        </a>
                                        <div class="article-label">
                                            <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Accessories</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a   class="">The Variety Of Styles And Prices Are Endless</a>
                                        </div>
                                        <div class="article-btn">
                                            <a   class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">

                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a  >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-8.jpg" src="/assets/images/blog/blog-8.jpg" alt="" />
                                        </a>
                                        <div class="article-label">
                                            <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Design</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a   class="">Something About This Style Of Jeans</a>
                                        </div>
                                        <div class="article-btn">
                                            <a   class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                        </div>
                        <div class="col-xl-4 col-md-6 col-12">
                            <Link to="/blogdetails" className="item-link">

                                <div class="blog-article-item">
                                    <div class="article-thumb">
                                        <a  >
                                            <img class="lazyload" data-src="/assets/images/blog/blog-9.jpg" src="/assets/images/blog/blog-9.jpg" alt="" />
                                        </a>
                                        <div class="article-label">
                                            <a   class="tf-btn btn-sm radius-3 btn-fill animate-hover-btn">Tech</a>
                                        </div>
                                    </div>
                                    <div class="article-content">
                                        <div class="article-title">
                                            <a   class="">One Of The Most Iconic Fashion Bloggers</a>
                                        </div>
                                        <div class="article-btn">
                                            <a   class="tf-btn btn-line fw-6">Read more<i class="icon icon-arrow1-top-left"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- /blog-grid-main --> */}

        </>
    )
}
export default BlogContent;